import React, { useState } from "react";
import cloudStore from "../store/CloudStore";
import { Button, FormControlLabel, Grid, Paper, Switch, Typography } from "@material-ui/core";
import withIntl from "../utils/withIntl";
import { _get, _post } from "../Api";
import { toast } from "react-toastify";
import { setMerchant } from "../store/CloudActions";
import CircularProgress from "@material-ui/core/CircularProgress";
import EditTextField from "../components/EditArticle/EditTextField";

const visibleHubriseFields = {
  account_name: { name: "Account" },
  location_id: { name: "Location" },
  catalog_id: { name: "Catalog" },
  currency_iso_4217: { name: "Currency" },
};

const serviceTypes = { takeaway: { name: "Takeaway" }, delivery: { name: "Delivery" } };

function Hubrise(props) {
  const [hubriseMerchant, setHubriseMerchant] = useState(cloudStore.merchant.hubrise_merchant);
  const [waitingForApiCall, setWaitingForApiCall] = useState(false);

  const paymentMethodsMerchant = [];
  cloudStore.merchant.ta_merchants.map((taMerchant) => {
    if (taMerchant.payment_methods != null) {
      JSON.parse(taMerchant.payment_methods).forEach((paymentMethod) => {
        if (
          !paymentMethodsMerchant
            .map((uniqueMethod) => Object.keys(uniqueMethod)[0])
            .includes(Object.keys(paymentMethod)[0])
        ) {
          paymentMethodsMerchant.push(paymentMethod);
        }
      });
    }
  });

  if (hubriseMerchant == null) {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography>Setup Hubrise merchant</Typography>
        </Grid>
        <Grid item xs={12}>
          <Button
            variant={"outlined"}
            onClick={() => {
              updateHubrise({ merchant_id: cloudStore.merchant.id }).then((hubriseMerchant) => {
                setHubriseMerchant(hubriseMerchant);
              });
            }}
          >
            Create
          </Button>
        </Grid>
      </Grid>
    );
  }

  function syncCatalog(hubriseMerchant) {
    setWaitingForApiCall(true);
    return _post(`/nova/v2/hubrise_merchants/${hubriseMerchant.id}/catalog/sync`)
      .catch((err) => {
        toast.error("Something went wrong.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setWaitingForApiCall(false);
        return Promise.reject();
      })
      .then((res) => {
        setWaitingForApiCall(false);
        return Promise.resolve(res.data);
      });
  }

  function pushCatalog(hubriseMerchant) {
    setWaitingForApiCall(true);
    return _post(`/nova/v2/hubrise_merchants/${hubriseMerchant.id}/pushCatalog`)
      .catch((err) => {
        toast.error("Something went wrong.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setWaitingForApiCall(false);
        return Promise.reject();
      })
      .then((res) => {
        toast.success("Saved", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setWaitingForApiCall(false);
        return Promise.resolve(res.data);
      });
  }

  if (waitingForApiCall) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <Paper style={{ padding: 8 }}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant={"h6"}>HubRise</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography style={{ fontStyle: "italic" }}>Share data with other applications</Typography>
        </Grid>
        {!hubriseMerchant.access_token && (
          <Grid item xs={12}>
            <Button
              variant={"outlined"}
              onClick={() => {
                connectHubrise(hubriseMerchant).then((url) => {
                  window.location = url.connection_url;
                });
              }}
            >
              Connect to HubRise
            </Button>
          </Grid>
        )}
        {hubriseMerchant.access_token && (
          <Grid item xs={12}>
            <Button
              variant={"outlined"}
              onClick={() => {
                window.location = "https://manager.hubrise.com/";
              }}
            >
              Go to HubRise
            </Button>
            <Button
              variant={"outlined"}
              onClick={() => {
                disconnectHubrise(hubriseMerchant).then((hubriseMerchant) => {
                  setHubriseMerchant(hubriseMerchant);
                });
              }}
            >
              Disconnect HubRise
            </Button>
          </Grid>
        )}

        {hubriseMerchant.access_token && (
          <>
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Switch
                    color={"primary"}
                    checked={hubriseMerchant.online_ordering}
                    onChange={(e) => {
                      updateHubrise({ ...hubriseMerchant, online_ordering: e.target.checked }).then(
                        (hubriseMerchant) => {
                          setHubriseMerchant(hubriseMerchant);
                        }
                      );
                    }}
                  />
                }
                label={"Online Ordering"}
              />
              {hubriseMerchant.access_token && hubriseMerchant.catalog_id && hubriseMerchant.online_ordering != false && (
                <>
                  <br />
                  <Button
                    variant={"outlined"}
                    onClick={() => {
                      syncCatalog(hubriseMerchant).then(() => {});
                    }}
                  >
                    Sync catalog from HubRise
                  </Button>
                </>
              )}
            </Grid>
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Switch
                    color={"primary"}
                    checked={hubriseMerchant.epos}
                    onChange={(e) => {
                      updateHubrise({ ...hubriseMerchant, epos: e.target.checked }).then((hubriseMerchant) => {
                        setHubriseMerchant(hubriseMerchant);
                      });
                    }}
                  />
                }
                label={"EPOS"}
              />
              {hubriseMerchant.access_token && hubriseMerchant.catalog_id && hubriseMerchant.epos != false && (
                <>
                  <br />
                  <Button
                    variant={"outlined"}
                    onClick={() => {
                      pushCatalog(hubriseMerchant).then(() => {});
                    }}
                  >
                    Push catalog
                  </Button>
                </>
              )}
            </Grid>
          </>
        )}
        <Grid item xs={6}>
          Account
        </Grid>
        <Grid item xs={6}>
          {hubriseMerchant["account_name"]}
        </Grid>
        <Grid item xs={6}>
          Location
        </Grid>
        <Grid item xs={6}>
          {hubriseMerchant["location_name"]} - {hubriseMerchant["location_id"]}
        </Grid>
        <Grid item xs={6}>
          Catalog
        </Grid>
        <Grid item xs={6}>
          {hubriseMerchant["catalog_name"]} - {hubriseMerchant["catalog_id"]}
        </Grid>
      </Grid>

      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant={"h6"}>Ref codes</Typography>
        </Grid>
        <Grid item xs={6}>
          Delivery charges ref code
        </Grid>
        <Grid item xs={6}>
          <EditTextField
            label={"Delivery charge ref code"}
            value={hubriseMerchant.charges?.delivery?.code}
            onBlur={(value, setBeginValue) => {
              let newHubriseMerchant = JSON.parse(JSON.stringify(hubriseMerchant));

              if (newHubriseMerchant.charges == null) {
                newHubriseMerchant.charges = {};
              }
              if (newHubriseMerchant.charges.delivery == null) {
                newHubriseMerchant.charges.delivery = {};
              }
              newHubriseMerchant.charges.delivery.code = value;
              updateHubrise(newHubriseMerchant).then((hubriseMerchant) => {
                setHubriseMerchant(hubriseMerchant);
                setBeginValue(hubriseMerchant.charges.delivery.code);
              });
            }}
          />
        </Grid>
        {paymentMethodsMerchant.map((paymentMethod) => {
          const paymentMethodName = Object.keys(paymentMethod)[0];
          return (
            <>
              <Grid item xs={6}>
                Payment fee ref code {paymentMethodName}
              </Grid>
              <Grid item xs={6}>
                <EditTextField
                  label={"Payment fee ref code"}
                  value={hubriseMerchant.charges?.payments?.[paymentMethodName]?.code}
                  onBlur={(value, setBeginValue) => {
                    let newHubriseMerchant = JSON.parse(JSON.stringify(hubriseMerchant));

                    if (newHubriseMerchant.charges == null) {
                      newHubriseMerchant.charges = {};
                    }
                    if (newHubriseMerchant.charges.payments == null) {
                      newHubriseMerchant.charges.payments = {};
                    }
                    if (newHubriseMerchant.charges.payments[paymentMethodName] == null) {
                      newHubriseMerchant.charges.payments[paymentMethodName] = {};
                    }
                    newHubriseMerchant.charges.payments[paymentMethodName].code = value;
                    updateHubrise(newHubriseMerchant).then((hubriseMerchant) => {
                      setHubriseMerchant(hubriseMerchant);
                      setBeginValue(hubriseMerchant.charges.payments[paymentMethodName].code);
                    });
                  }}
                />
              </Grid>
            </>
          );
        })}
        {paymentMethodsMerchant.map((paymentMethod) => {
          const paymentMethodName = Object.keys(paymentMethod)[0];
          return (
            <>
              <Grid item xs={6}>
                Payment method ref code {paymentMethodName}
              </Grid>
              <Grid item xs={6}>
                <EditTextField
                  label={"Payment method ref code"}
                  value={hubriseMerchant.payments?.[paymentMethodName]?.code}
                  onBlur={(value, setBeginValue) => {
                    let newHubriseMerchant = JSON.parse(JSON.stringify(hubriseMerchant));

                    if (newHubriseMerchant.payments == null) {
                      newHubriseMerchant.payments = {};
                    }
                    if (newHubriseMerchant.payments[paymentMethodName] == null) {
                      newHubriseMerchant.payments[paymentMethodName] = {};
                    }
                    newHubriseMerchant.payments[paymentMethodName].code = value;
                    updateHubrise(newHubriseMerchant).then((hubriseMerchant) => {
                      setHubriseMerchant(hubriseMerchant);
                      setBeginValue(hubriseMerchant.payments[paymentMethodName].code);
                    });
                  }}
                />
              </Grid>
            </>
          );
        })}

        {Object.keys(serviceTypes).map((serviceType) => {
          return (
            <>
              <Grid item xs={6}>
                Service Type ref code {serviceTypes[serviceType].name}
              </Grid>
              <Grid item xs={6}>
                <EditTextField
                  label={"Service type ref code"}
                  value={hubriseMerchant.service_types?.[serviceType]?.code}
                  onBlur={(value, setBeginValue) => {
                    let newHubriseMerchant = JSON.parse(JSON.stringify(hubriseMerchant));

                    if (newHubriseMerchant.service_types == null) {
                      newHubriseMerchant.service_types = {};
                    }
                    if (newHubriseMerchant.service_types[serviceType] == null) {
                      newHubriseMerchant.service_types[serviceType] = {};
                    }
                    newHubriseMerchant.service_types[serviceType].code = value;
                    updateHubrise(newHubriseMerchant).then((hubriseMerchant) => {
                      setHubriseMerchant(hubriseMerchant);
                      setBeginValue(hubriseMerchant.service_types[serviceType].code);
                    });
                  }}
                />
              </Grid>
            </>
          );
        })}
      </Grid>
    </Paper>
  );
}

function updateHubrise(hubriseMerchant) {
  let data = { ...hubriseMerchant };

  return _post(`/nova/v2/hubrise_merchants/update`, [data])
    .catch((err) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject();
    })
    .then((res) => {
      let updatedMerchant = { ...cloudStore.merchant };
      updatedMerchant.hubrise_merchant = res.data[0];
      updatedMerchant.hubrise_merchant_id = res.data[0].id;

      setMerchant(updatedMerchant);
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data[0]);
    });
}

function connectHubrise(hubriseMerchant) {
  return _post(`/nova/v2/hubrise_merchants/${hubriseMerchant.id}/connect`)
    .catch((err) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject();
    })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

function disconnectHubrise(hubriseMerchant) {
  return _post(`/nova/v2/hubrise_merchants/${hubriseMerchant.id}/disconnect`)
    .catch((err) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject();
    })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

function getCatalogs(hubriseMerchant) {
  return _get(`/nova/v2/hubrise_merchants/${hubriseMerchant.id}/catalogs`)
    .catch((err) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject();
    })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export default withIntl(Hubrise);
